module.exports = __webpack_public_path__ + "static/media/lakewoode-park-homes-bylaws.49ff8231.pdf";